import React from "react";
import {IonItem, IonList} from "@ionic/react";
import {getManager} from "../../../../ts/manager/Manager";
import ApiResponseVO from "../../../../ts/manager/api/ApiResonseVO";
import BasicForm from "../../../component/form/BasicForm";
import InputFIE from "../../../component/form/form-item-element/InputFIE";
import AppButton from "../../../element/button/AppButton";
import StateViewController from "../../../vc/StateViewController";
import {IRouteProps} from "../../../../ts/manager/view/ViewInterface";


class AccountEditProfileForm extends BasicForm
{

    async handleSubmitItems(formItemIDs: string[]|null): Promise<ApiResponseVO>
    {
        const params = this.collectParams(formItemIDs);
        return await getManager().api.fetchData("/account/profile/update", "POST", params, true).then((responseVO: ApiResponseVO) =>
        {
            if (!responseVO.apiError)
            {
                getManager().user.profile.firstName = this.stringItem("first_name").getCastValue()
                getManager().user.profile.lastName = this.stringItem("last_name").getCastValue();
            }
            return responseVO;
        });
    }

    handleSubmitComplete()
    {
     //  manager.user.dispatchUserUpdateListeners();
    }

    renderComponent()
    {

        return <>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <form
                            onSubmit={this.handleFormSubmit}
                            className={"custom-form "+(this.isDisabled() ? "content-disabled" : "")}
                        >

                            {this.startFormAlerts()}
                            {this.requiredFieldsMessage()}
                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <InputFIE
                                        form={this}
                                        formItemProps={{
                                            pointer: "first_name",
                                            name: "First Name",
                                            value: getManager().user.profile.firstName
                                        }}
                                    />
                                </div>
                                <div className="col-12 col-lg-6">
                                    <InputFIE
                                        form={this}
                                        formItemProps={{
                                            pointer: "last_name",
                                            name: "Last Name",
                                            value: getManager().user.profile.lastName
                                        }}
                                    />
                                </div>
                            </div>

                            {this.endFormAlerts()}
                            <div className="clearfix">
                                <div className="form-group float-start mt-4">
                                    <AppButton
                                        type="submit"
                                        loading={this.loading}
                                        className="btn btn-block btn-primary"
                                        disabled={this.isSubmitDisabled()}
                                    >
                                        Edit Profile
                                    </AppButton>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>

        </>;
    }
}

const AccountEditProfilePage = (props:IRouteProps) =>
{

    const viewState = StateViewController({
        routeProps: props
    })

    if(viewState.overrideView){
        return viewState.overrideView;
    }

    return <>
        <section className="content-block">
            <AccountEditProfileForm
                routeProps={props}
            />
        </section>
    </>
}

export default AccountEditProfilePage;